import { lazyNamedImport } from "@infinidus/react-utils";
import { Suspense } from "react";

const { Fallback } = lazyNamedImport(
  () => import("@/features/fallback/view"),
  "Fallback",
);

const { AppRouter } = lazyNamedImport(
  () => import("@/features/routing"),
  "AppRouter",
);

const { InfinidusMarketing } = lazyNamedImport(
  () => import("./InfinidusMarketing"),
  "InfinidusMarketing",
);

const { ErrorBoundary } = lazyNamedImport(
  () => import("@infinidus/react-utils"),
  "ErrorBoundary",
);

export const App = () => {
  return (
    <ErrorBoundary
      fallback={
        <Suspense fallback={null}>
          <Fallback reason="GenericError" />
        </Suspense>
      }
    >
      <Suspense fallback={null}>
        <InfinidusMarketing>
          <AppRouter />
        </InfinidusMarketing>
      </Suspense>
    </ErrorBoundary>
  );
};
